
export default function NavLeftDirective() {
    return {
        template: require('./left.component.html'),
        restrict: 'E',
        scope: {
            module: '=?'
        },
        controller: NavLeftController
    };
}

class NavLeftController {
    constructor($scope, navService) {

        'ngInject';

        this.$scope = $scope;
        this.navService = navService;

        this.$scope.module = this.navService.getCurrentModule();

        this.$scope.groupList = [];

        this.$scope.ungroupedItems = [];

        for (var key in this.$scope.module.groups) {
            this.$scope.groupList.push(this.$scope.module.groups[key]);
        }

        for (var itemKey in this.$scope.module.items) {

            //check to see if sub items are allowed
            if (!(navService.isValidState(this.$scope.module.items[itemKey].sref))) {
                continue;
            }

            //try and find the group that this belongs tooo
            let itemGroup = null;
            for (let groupKey in this.$scope.groupList) {
                if (this.$scope.groupList[groupKey].id === this.$scope.module.items[itemKey].group) {
                    itemGroup = this.$scope.groupList[groupKey];
                    break;
                }
            }

            if (itemGroup) {
                if (!itemGroup.items) {
                    itemGroup.items = [];
                }
                // Only add the sub-items once.
                let itemMatch = false;
                for (var i = 0; i < itemGroup.items.length; i++) {
                    if (itemGroup.items[i].sref === this.$scope.module.items[itemKey].sref) {
                        itemMatch = true;
                        break;
                    }
                }

                if (!itemMatch) {
                    itemGroup.items.push(this.$scope.module.items[itemKey]);
                }
            } else {
                this.$scope.ungroupedItems.push(this.$scope.module.items[itemKey]);
            }
        }
    }
}